import React, { FunctionComponent } from 'react';

import styles from './AudioTextRow.module.scss';
import { MusicIcon } from 'app/assets/images/icons';

interface Props {
  data: any;
}

const AudioTextRow: FunctionComponent<Props> = ({ data }) => {
  return !!data?.audio_name?.length ? (
    <div className={styles.AudioTextRow}>
      {!!data?.audio_owner_name?.length ? (
        <span>{data?.audio_owner_name}</span>
      ) : (
        <></>
      )}
      {!!data?.audio_owner_name?.length ? <span>|</span> : <></>}
      {!!data?.audio_name ? <span>{data?.audio_name}</span> : <></>}
      <MusicIcon />
    </div>
  ) : (
    <></>
  );
};

export default AudioTextRow;
